// import {createSlice} from "@reduxjs/toolkit";

// const fetchFromLocalStorage = () => {
//     let cart = localStorage.getItem('cart');
//     if(cart){
//         return JSON.parse(localStorage.getItem('cart'));
//     } else {
//         return [];
//     }
// }

// const storeInLocalStorage = (data) => {
//     localStorage.setItem('cart', JSON.stringify(data));
// }

// const initialState = {
//     carts: fetchFromLocalStorage(),
//     itemsCount: 0,
//     totalAmount: 0,
//     isCartMessageOn: false
// }

// const cartSlice = createSlice({
//     name: 'cart',
//     initialState,
//     reducers: {
//         addToCart: (state, action) => {
//             const isItemInCart = state.carts.find(item => item.id === action.payload.id);

//             if(isItemInCart){
//                 const tempCart = state.carts.map(item => {
//                     if(item.id === action.payload.id){
//                         let tempQty = item.quantity + action.payload.quantity;
//                         let tempTotalPrice = tempQty * item.price;

//                         return {
//                             ...item, quantity: tempQty, totalPrice: tempTotalPrice
//                         }
//                     } else {
//                         return item;
//                     }
//                 });

//                 state.carts = tempCart;
//                 storeInLocalStorage(state.carts);
//             } else {
//                 state.carts.push(action.payload);
//                 storeInLocalStorage(state.carts);
//             }
//         },

//         removeFromCart: (state, action) => {
//             const tempCart = state.carts.filter(item => item.id !== action.payload);
//             state.carts = tempCart;
//             storeInLocalStorage(state.carts);
//         },

//         clearCart: (state) => {
//             state.carts = [];
//             storeInLocalStorage(state.carts);
//         },

//         getCartTotal: (state) => {
//             state.totalAmount = state.carts.reduce((cartTotal, cartItem) => {
//                 return cartTotal += cartItem.totalPrice
//             }, 0);

//             state.itemsCount = state.carts.length;
//         },

//         toggleCartQty: (state, action) => {
//             const tempCart = state.carts.map(item => {
//                 if(item.id === action.payload.id){
//                     let tempQty = item.quantity;
//                     let tempTotalPrice = item.totalPrice;

//                     if(action.payload.type === "INC"){
//                         tempQty++;
//                         if(tempQty === item.stock) tempQty = item.stock;
//                         tempTotalPrice = tempQty * item.discountedPrice;
//                     }

//                     if(action.payload.type === "DEC"){
//                         tempQty--;
//                         if(tempQty < 1) tempQty = 1;
//                         tempTotalPrice = tempQty * item.discountedPrice;
//                     }

//                     return {...item, quantity: tempQty, totalPrice: tempTotalPrice};
//                 } else {
//                     return item;
//                 }
//             });

//             state.carts = tempCart;
//             storeInLocalStorage(state.carts);
//         },

//         setCartMessageOn: (state) => {
//             state.isCartMessageOn = true;
//         },

//         setCartMessageOff: (state) => {
//             state.isCartMessageOn = false;
//         }
//     }
// });

// export const {addToCart, setCartMessageOff, setCartMessageOn, getCartTotal, toggleCartQty, clearCart, removeFromCart} = cartSlice.actions;
// export const getAllCarts = (state) => state.cart.carts;
// export const getCartItemsCount = (state) => state.cart.itemsCount;
// export const getCartMessageStatus = (state) => state.cart.isCartMessageOn;

// export default cartSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL1 } from "../utils/apiURL";

// Fonction pour récupérer le panier du localStorage
const fetchFromLocalStorage = () => {
  let cart = localStorage.getItem("cart");
  return cart ? JSON.parse(cart) : [];
};

// Fonction pour stocker le panier dans le localStorage
const storeInLocalStorage = (data) => {
  localStorage.setItem("cart", JSON.stringify(data));
};

// État initial du slice
const initialState = {
  carts: fetchFromLocalStorage(),
  itemsCount: 0,
  totalAmount: 0,
  isCartMessageOn: false,
  loading: false,
  error: null,
};

// Action asynchrone pour ajouter un produit au panier
export const addToCartAsync = createAsyncThunk(
  "cart/addToCartAsync",
  async ({ product_id, quantity, token }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL1}add/cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Ajout du token d'authentification
        },
        body: JSON.stringify({ product_id, quantity }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const data = await response.json();
      return data.cart; // Assurez-vous que cela renvoie la bonne réponse
    } catch (error) {
      return rejectWithValue({ message: "Une erreur s'est produite." });
    }
  }
);

// Action asynchrone pour récupérer les produits du panier
export const fetchCartProductsAsync = createAsyncThunk(
  "cart/fetchCartProductsAsync",
  async (token, { rejectWithValue }) => {
    // Pas besoin d'encapsuler le token dans un objet
    try {
      const response = await fetch(`${BASE_URL1}get/cart`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Ajout du token d'authentification
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const data = await response.json();
      return data.cart; // Assurez-vous que cela renvoie la bonne réponse
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des produits du panier:",
        error
      ); // Ajout d'un log d'erreur
      return rejectWithValue({ message: "Une erreur s'est produite." });
    }
  }
);

// Action asynchrone pour supprimer un produit du panier
export const removeFromCartAsync = createAsyncThunk(
  "cart/removeFromCartAsync",
  async ({ product_id, token }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL1}remove/From/Cart`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Inclure le token si nécessaire
        },
        body: JSON.stringify({ product_id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      return product_id; // Retourne l'ID du produit supprimé
    } catch (error) {
      return rejectWithValue({ message: "Une erreur s'est produite." });
    }
  }
);

// Création du slice pour le panier
const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    clearCart: (state) => {
      state.carts = [];
      storeInLocalStorage(state.carts);
    },

    getCartTotal: (state) => {
      state.totalAmount = state.carts.reduce((cartTotal, cartItem) => {
        return cartTotal + cartItem.totalPrice;
      }, 0);
      state.itemsCount = state.carts.length;
    },

    toggleCartQty: (state, action) => {
      const tempCart = state.carts.map((item) => {
        if (item.id === action.payload.id) {
          let tempQty = item.quantity;
          let tempTotalPrice = item.totalPrice;

          if (action.payload.type === "INC") {
            tempQty++;
            if (tempQty === item.stock) tempQty = item.stock;
            tempTotalPrice = tempQty * item.discountedPrice;
          }

          if (action.payload.type === "DEC") {
            tempQty--;
            if (tempQty < 1) tempQty = 1;
            tempTotalPrice = tempQty * item.discountedPrice;
          }

          return { ...item, quantity: tempQty, totalPrice: tempTotalPrice };
        }
        return item;
      });

      state.carts = tempCart;
      storeInLocalStorage(state.carts);
    },

    setCartMessageOn: (state) => {
      state.isCartMessageOn = true;
    },

    setCartMessageOff: (state) => {
      state.isCartMessageOn = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addToCartAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToCartAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.carts.push(action.payload);
        storeInLocalStorage(state.carts);
      })
      .addCase(addToCartAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      .addCase(fetchCartProductsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCartProductsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.carts = action.payload; // Met à jour les produits du panier
        storeInLocalStorage(state.carts); // Met à jour le localStorage
      })
      .addCase(fetchCartProductsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message; // Gérer les erreurs
      })
      .addCase(removeFromCartAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeFromCartAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.carts = state.carts.filter((item) => item.id !== action.payload); // Supprimez le produit du panier
        storeInLocalStorage(state.carts); // Met à jour le localStorage
      })
      .addCase(removeFromCartAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message; // Gérer les erreurs
      });
  },
});

// Export des actions et sélecteurs
export const {
  clearCart,
  setCartMessageOff,
  setCartMessageOn,
  getCartTotal,
  toggleCartQty,
} = cartSlice.actions;

export const getAllCarts = (state) => state.cart.carts;
export const getCartItemsCount = (state) => state.cart.itemsCount;
export const getCartMessageStatus = (state) => state.cart.isCartMessageOn;
export const getCartLoading = (state) => state.cart.loading;
export const getCartError = (state) => state.cart.error;

export default cartSlice.reducer;
